import { PrimitiveDropdownOptionPipe } from '@app/sharedModule/pipes/pipes';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';
import { CheckoutContentExtension, CheckoutExtensionUI } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { capitalize } from '@utils/string-utils';
import BlockType = CheckoutContentExtension.BlockType;

export interface CheckoutContentFormValue extends CheckoutContentExtension.Template {
  blocks: CheckoutContentBlockValue[];
}

export interface CheckoutContentBlockValue extends CheckoutContentExtension.Block {
  imagePreviewBase64?: string;
  imageFile?: any;
}

export const ExtensionBlockModeDisplayName = new Map<CheckoutContentExtension.BlockMode, string>([
  [CheckoutContentExtension.BlockMode.SIMPLE, 'Simple'],
  [CheckoutContentExtension.BlockMode.BULLET, 'Bullet points'],
  [CheckoutContentExtension.BlockMode.NUMBER, 'Numbered'],
]);

export const blockTypeOptions: DropdownOption[] = Object.values(CheckoutContentExtension.BlockType).map((value) =>
  PrimitiveDropdownOptionPipe.prototype.transform(value, capitalize),
);

export const styleOptions: DropdownOption[] = Object.values(CheckoutContentExtension.StyleType).map((value) =>
  PrimitiveDropdownOptionPipe.prototype.transform(value, capitalize),
);

export const borderWidthOptions: DropdownOption[] = Object.values(CheckoutExtensionUI.BorderWidth).map((value) =>
  PrimitiveDropdownOptionPipe.prototype.transform(value, capitalize),
);
export const borderTypeOptions: DropdownOption[] = Object.values(CheckoutExtensionUI.BorderType).map((value) =>
  PrimitiveDropdownOptionPipe.prototype.transform(value, capitalize),
);
export const cornerRadiusOptions: DropdownOption[] = Object.values(CheckoutExtensionUI.CornerRadius).map((value) =>
  PrimitiveDropdownOptionPipe.prototype.transform(value, capitalize),
);

export const paddingOptions: DropdownOption[] = Object.values(CheckoutExtensionUI.Padding).map((value) =>
  PrimitiveDropdownOptionPipe.prototype.transform(value, capitalize),
);

export const blockModeOptions: DropdownOption[] = Object.values(CheckoutContentExtension.BlockMode).map((value) =>
  PrimitiveDropdownOptionPipe.prototype.transform(value, () => ExtensionBlockModeDisplayName.get(value)),
);

export const ExtensionToCssPadding = new Map<CheckoutExtensionUI.Padding, string>([
  [CheckoutExtensionUI.Padding.SMALL500, '3px'],
  [CheckoutExtensionUI.Padding.SMALL400, '5px'],
  [CheckoutExtensionUI.Padding.SMALL300, '7px'],
  [CheckoutExtensionUI.Padding.SMALL200, '9px'],
  [CheckoutExtensionUI.Padding.SMALL100, '11px'],
  [CheckoutExtensionUI.Padding.BASE, '14px'],
  [CheckoutExtensionUI.Padding.LARGE100, '17px'],
  [CheckoutExtensionUI.Padding.LARGE200, '21px'],
  [CheckoutExtensionUI.Padding.LARGE300, '26px'],
  [CheckoutExtensionUI.Padding.LARGE400, '32px'],
  [CheckoutExtensionUI.Padding.LARGE500, '38px'],
]);

export const ExtensionToCssBorderRadius = new Map<CheckoutExtensionUI.CornerRadius, string>([
  [CheckoutExtensionUI.CornerRadius.SMALL, '2px'],
  [CheckoutExtensionUI.CornerRadius.BASE, '5px'],
  [CheckoutExtensionUI.CornerRadius.LARGE, '10px'],
  [CheckoutExtensionUI.CornerRadius.FULLY_ROUNDED, '36px'],
  [CheckoutExtensionUI.CornerRadius.NONE, '0'],
]);

export const ExtensionToCssBorderWidth = new Map<CheckoutExtensionUI.BorderWidth, string>([
  [CheckoutExtensionUI.BorderWidth.BASE, '1px'],
  [CheckoutExtensionUI.BorderWidth.MEDIUM, '2px'],
]);
export const ExtensionToCssBorderType = new Map<CheckoutExtensionUI.BorderType, string>([
  [CheckoutExtensionUI.BorderType.BASE, 'solid'],
  [CheckoutExtensionUI.BorderType.DOTTED, 'dotted'],
  [CheckoutExtensionUI.BorderType.NONE, 'none'],
]);

export function getBlockImageSrc(
  block: CheckoutContentExtension.ImageBlock | CheckoutContentExtension.DynamicBlock,
): string {
  return block?.imageUrl?.trim() ? block.imageUrl : (block?.image ?? '');
}
